module.exports = __webpack_public_path__ + "img/snqy.8eb1148.png";